import { ApiError, api } from "@/lib/api";

export type BrandMembershipRole = { value: string; label: string };

export type BrandMembershipUser = {
  display_label: string;
  email: string | null;
  phone: string | null;
};

export type BrandMembership = {
  id: number;
  user_id: number;
  role: string;
  user: BrandMembershipUser;
};

export type BrandMembershipCandidate = {
  user_id: number;
  display_label: string;
  email: string | null;
  phone: string | null;
  granted: boolean;
};

export type BrandMembershipsPayload = {
  brand_id: number;
  roles: BrandMembershipRole[];
  memberships: BrandMembership[];
  candidates: BrandMembershipCandidate[];
};

function basePath(accountId: string | number, brandId: string | number) {
  return `/accounts/${accountId}/brands/${brandId}/memberships`;
}

export async function fetchBrandMemberships(
  accountId: string | number,
  brandId: string | number,
): Promise<BrandMembershipsPayload> {
  return api.fetchForAccount(accountId, basePath(accountId, brandId));
}

export async function createBrandMembership(
  accountId: string | number,
  brandId: string | number,
  body: { user_id: number; role?: string },
): Promise<{ membership: BrandMembership }> {
  return api.fetchForAccount(accountId, basePath(accountId, brandId), {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function updateBrandMembership(
  accountId: string | number,
  brandId: string | number,
  membershipId: number,
  body: { role: string },
): Promise<{ membership: BrandMembership }> {
  return api.fetchForAccount(accountId, `${basePath(accountId, brandId)}/${membershipId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export async function deleteBrandMembership(
  accountId: string | number,
  brandId: string | number,
  membershipId: number,
): Promise<void> {
  await api.fetchForAccount(accountId, `${basePath(accountId, brandId)}/${membershipId}`, {
    method: "DELETE",
  });
}

export { ApiError };
